module.exports = __webpack_public_path__ + "img/akord.1045cc3c.svg";